import { Observable } from 'rxjs';
import {
  Component,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
} from '@angular/core';

import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
} from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import Swal from 'sweetalert2';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { RightHeldDto } from '@cradua/data';

@Component({
  selector: 'cradua-right-held',
  templateUrl: './right-held.component.html',
  styleUrls: ['./right-held.component.scss'],
})
export class RightHeldComponent implements OnChanges {
  rightheldForm: FormGroup;
  rightheldFormArray: FormGroup;
  control = new FormControl();
  @Input() righthelds: RightHeldDto[];
  @Input() routeAnimationsElements: any;
  @Output() rightheld = new EventEmitter<RightHeldDto[]>();
  @Output() deleteRightHeldEvent = new EventEmitter<any>();

  selectedRightHeld: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createRightHeldForm();
  }

  createRightHeldForm() {
    this.rightheldForm = this.fb.group({
      RightHeldName: ['', Validators.required],
      id: null,
    });
    this.rightheldFormArray = this.fb.group({ RightHelds: this.fb.array([]) });
    this.setRightHeld();
  }

  // method to display righthelds
  setRightHeld() {
    const control = this.rightheldFormArray.controls.RightHelds as FormArray;
    this.righthelds.forEach((e) => {
      control.push(
        this.fb.group({
          RightHeldName: e.RightHeldName,
          id: e.id,
        })
      );
    });
  }

  // method to add RightHeld
  addRightHeld(value: RightHeldDto) {
    const control = this.rightheldFormArray.controls.RightHelds as FormArray;
    control.insert(
      0,
      this.fb.group({
        RightHeldName: value.RightHeldName,
        id: null,
      })
    );
  }

  selectRightHeld(value) {}

  // method to delete rightheld from arrary list
  deleteRightHeld(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.rightheldFormArray.controls
          .RightHelds as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.righthelds.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.righthelds[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: RightHeldDto) {
    if (this.rightheldForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.rightheldFormArray
        .get('RightHelds')
        ['controls'][this.selectedIndex].patchValue({
          RightHeldName: formValue.RightHeldName,
        });
    } else {
      this.addRightHeld(formValue);
    }
    this.selectedIndex = null;
    this.rightheldForm.reset();
  }

  onEdit(index, value: RightHeldDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.rightheldForm.patchValue({ RightHeldName: value.RightHeldName });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.rightheldForm.reset();
  }

  onSubmit(formValue: RightHeldDto[]) {
    this.rightheld.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteRightHeldEvent.emit(this.filteredDelete);
    }
  }
}
